import styled from 'styled-components'
import theme from '../../theme/theme';
import { Help as MuiHelp } from "@mui/icons-material";

export const MainWrapper = styled.div`
margin: 0 5% 5%;
`;

export const HeaderWrapper = styled.div`
@media (max-width: 400px) {
  margin-left: 20px;
}
`;

export const Title = styled.h1`
  font-family: 'Inter', sans-serif;
  font-size: 55px;
  margin: 0;
  font-weight: 800;
  padding-top: 50px;
  margin-bottom: 15px;
  color: ${theme.color.navy};
  @media (max-width: 420px) {
    font-size: 40px;
    padding-top: 30px;
  }
`;

export const Wrapper = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
margin-top: 3%;

@media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    margin: 10px auto;
}
`;

export const Box = styled.div`
display: flex;
justify-content: space-between;
width: 45%;
border: none;
min-height: 100%;
padding: 10px;

@media (max-width: 768px) {
    width: 80%;
    justify-content: center;
    margin: 10px auto;
}
`;

export const InsideBox = styled.div`
min-height: 250px;
height: 100%;
width: 30%;
box-shadow: 0 4px 4px rgba(0,0,0, 0.25);
border: none;
border-radius: 14px;
margin: 0px 4px;
flex-grow: 1;
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: center;
padding: 10px;
`;

export const InvisibleBox = styled.div`
width: 45%;
border: none;
padding: 10px;
height: 100%;

@media (max-width: 768px) {
    display: none;
}
`;

export const Header = styled.h2`
font-size: 1.8rem;
font-weight: 700;
color: ${theme.color.navy};
text-align: center;

@media (max-width: 768px) {
    font-size: 1.4rem;
}
`;

export const Span = styled.span`
font-size: 1.6rem;
font-weight: 500;
color: ${theme.color.black};
text-align: center;

@media (max-width: 768px) {
    font-size: 1.2rem;
}
`;

export const Container = styled.div` 
    // margin: 0 4rem;
`;

export const MainHeaderContainer = styled.div`
display: flex;
align-items: center;
`;

export const CustomHelpIcon = styled(MuiHelp)`
  color: ${theme.color.silver};
  transition: color 0.3s ease-in-out;

  &:hover {
    color: ${theme.color.stone};
    transition: color 0.3s ease-in-out;
    cursor: pointer;
  }
`;

export const HelpContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${CustomHelpIcon} {
    color: ${theme.color.stone};
    transition: color 0.3s ease-in-out;
  }
`;

export const HelpIcon = styled.div`
margin: 2.5rem 0 0 0;
`;

export const HelpTooltip = styled.div`
  display: none;
  transition: display 0.5s ease;
  position: absolute;
  font-size: 14px;
  top: 35px;
  left: 35px;
  width: 400px;
  background-color: rgba(255, 255, 255, 0.6); /* Fondo blanco con opacidad */
  backdrop-filter: blur(15px); /* Efecto de desenfoque */
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  z-index: 100;

  @media (max-width: 400px) {
    top: 30px;
    left: -260px;
    width: 260px;
  }

  @media (max-width: 800px) and (min-width: 401px){
    top: 75px;
    left: -396px;
  }

  ${HelpContainer}:hover & {
    display: block;
    transition: display 0.5s ease;
  }

  p {
    margin: 0;
    line-height: 1.5;

    strong {
      font-weight: bold;
    }
  }
`;